/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_No_InsightsInputs */

const en_read_along_ai_no_insights = /** @type {(inputs: Read_Along_Ai_No_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No insights were returned. Try again.`)
};

const es_read_along_ai_no_insights = /** @type {(inputs: Read_Along_Ai_No_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se recibió información. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "No insights were returned. Try again." |
*
* @param {Read_Along_Ai_No_InsightsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_no_insights = /** @type {((inputs?: Read_Along_Ai_No_InsightsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_No_InsightsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_no_insights(inputs)
	return en_read_along_ai_no_insights(inputs)
});